import { createFileRoute, useParams } from '@tanstack/react-router'

import { RequestDrawer } from '../../../../components/request-drawer/components/RequestDrawer'

export const Route = createFileRoute('/app/requests/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  // Access the id parameter from the URL
  const { id } = useParams({ from: '/app/requests/$id/' })

  return <RequestDrawer requestId={id} />
}
